export enum EditLevel {
  NoEdit=0,
  Edit = 1,
  NoRights = 2,
  Unavailable=3
}
